import React from 'react';
import { ContentTemplate, Progress, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import SubmitApplication from '../../modules/withdrawal/SubmitApplication';
import RouteKey from '../../routes/key';
import { useGetWithdrawalAcknowledge } from '../../api/candidate/exam/@candidate/queries-services/queries';

const { withdrawal } = RouteKey.child;
const { examRegistrations, summary: withdrawalSummary } = RouteKey.exam.child;

const SubmitApplicationPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  const handleViewFullSummaryClick = () => {
    history.push(`/${withdrawal}/${examRegistrations.route}/${uuid}/${withdrawalSummary.route}`);
  };

  const {
    data: withdrawalReceiptDetails,
    isLoading: isLoadingWithdrawalReceiptDetails,
  } = useGetWithdrawalAcknowledge(uuid);

  return (
    <>
      <TitleHeader
        state="success"
        title={t('withdrawal->>SubmitApplication.ThankYouMessage')}
        largeContentContainer
      />
      {isLoadingWithdrawalReceiptDetails ? (
        <ContentTemplate>
          <Progress color="secondary" />
        </ContentTemplate>
      ) : (
        <>
          {withdrawalReceiptDetails && (
            <SubmitApplication
              handleViewFullSummaryClick={handleViewFullSummaryClick}
              withdrawalReceiptDetails={withdrawalReceiptDetails}
            />
          )}
        </>
      )}
    </>
  );
};

export default SubmitApplicationPage;
